const ITEMS = [
  "Antique Gold Plating",
  "Handcrafted by Master Artisans",
  "Temple • Bridal • Antique • American Diamond",
  "Timeless Elegance, Inspired by Tradition",
  "Insured Shipping Across India",
];

function Row({ hidden }) {
  return (
    <div aria-hidden={hidden} className="flex shrink-0 items-center">
      {ITEMS.map((t, i) => (
        <span key={i} className="flex items-center">
          <span className="px-8 font-cinzel text-[10px] sm:text-[11px] uppercase tracking-[0.3em] text-gold whitespace-nowrap">
            {t}
          </span>
          <svg width="13" height="13" viewBox="0 0 24 24" className="shrink-0 text-gold2/70" fill="currentColor">
            <path d="M12 2l2.4 7.6L22 12l-7.6 2.4L12 22l-2.4-7.6L2 12l7.6-2.4z" />
          </svg>
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div className="marquee overflow-hidden border-y border-gold/20 bg-bg2 py-5" data-testid="editorial-marquee">
      <div className="marquee-track">
        <Row hidden={false} />
        <Row hidden={true} />
      </div>
    </div>
  );
}
